<!-- MODAL Agregar Promocion -->
<div mdbModal #agregarPromocion="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          <ng-container *ngIf="mode === 'ADD'">
            Agregar promoción
          </ng-container>
          <ng-container *ngIf="mode === 'EDIT'">
            Editar promoción
          </ng-container>
          <ng-container *ngIf="mode === 'VIEW'">
            Ver promoción
          </ng-container>
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div [ngClass]="{'modal-body': true, 'disabledContent': mode === 'VIEW'}">
        <!-- Cabecera de botones -->


        <div class="filtros">
          <form [formGroup]="formHeader">
            <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
              <div class="">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Seleccionar clientes
                </h5>
              </div>
              <div></div>
            </div>
            <div class="row filtros-body">
              <div class="col" style="
                display: flex;
                align-items: center;
                justify-content: center;
              ">
                <strong>Buscar por: </strong>
                <!-- Material inline 1 -->
                <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input" id="tab_promociones_modal_rbBuscarPor_cliente"
                    formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput />
                  <!-- (change)='limpiarBuscarPorCliente()' -->
                  <label class="form-check-label" for="tab_promociones_modal_rbBuscarPor_cliente">Tipo cliente</label>
                </div>

                <!-- Material inline 2 -->
                <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input" id="tab_promociones_modal_rbBuscarPor_tipo_cliente"
                    formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput />
                  <!-- (change)='limpiarBuscarPorTiposClientes()' -->
                  <label class="form-check-label" for="tab_promociones_modal_rbBuscarPor_tipo_cliente">Cliente</label>
                </div>

                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccion()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>

                <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_CLIENTE">
                  <button mdbBtn type="button" class="" color="info" mdbWavesEffect [ngClass]="{'enabledContent': true}"
                    (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
                    ({{clientesSeleccionados.length | numerico}}) Seleccionados
                  </button>
                </ng-container>
                <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_TIPO_CLIENTE">
                  <button mdbBtn type="button" class="" color="info" mdbWavesEffect [ngClass]="{'enabledContent': true}"
                    (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                    *ngIf="tiposClientesSeleccionados?.length > 0">
                    ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
                  </button>
                </ng-container>

                <!-- <h6 class="text-info" style="cursor: pointer; pointer-events: all; opacity: 1;"
                  (click)="verClientesSeleccionados()" *ngIf="clientesSeleccionados">
                  Ver Clientes
                </h6> -->
                <!-- <h6 class="text-info" *ngIf="clientesSeleccionados">
                  {{ clientesSeleccionadosFormatted }}
                </h6> -->
                <!-- <h6 class="text-info" *ngIf="tiposClientesSeleccionados">
                  {{ tiposClientesSeleccionadosFormatted }}
                </h6> -->
                <h6 *ngIf="
                  formHeader.get('clienteOrTipos').invalid &&
                  (formHeader.get('clienteOrTipos').dirty ||
                  formHeader.get('clienteOrTipos').touched)
                ">
                  <mdb-error *ngIf="formHeader.get('clienteOrTipos').hasError('required')">Ingrese cliente o tipo(s) de
                    cliente(s)
                  </mdb-error>
                </h6>
              </div>

              <div class="col">
                <div class="row">
                  <div class="col" style="display: flex; align-items: center;">
                    <div class="switch info-switch">
                      <label>
                        Inactivo
                        <input type="checkbox" color="info" formControlName="activo" />
                        <span class="lever"></span> Activo
                      </label>
                    </div>
                  </div>

                  <div class="col">
                    <div class="md-form">
                      <mdb-date-picker #datePickerInicio [inline]="true" name="fechaInicio"
                        [placeholder]="'Fecha inicio'" required formControlName='fechaInicio'>
                      </mdb-date-picker>
                      <div *ngIf="
                        formHeader.get('fechaInicio').invalid &&
                        (formHeader.get('fechaInicio').dirty ||
                        formHeader.get('fechaInicio').touched)
                      ">
                        <mdb-error *ngIf="formHeader.get('fechaInicio').hasError('required')">Ingrese fecha inicio
                        </mdb-error>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="md-form">
                      <mdb-date-picker #datePickerFinal [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'"
                        required formControlName='fechaFin'>
                      </mdb-date-picker>
                      <div *ngIf="
                        formHeader.get('fechaFin').invalid &&
                        (formHeader.get('fechaFin').dirty ||
                        formHeader.get('fechaFin').touched)
                      ">
                        <mdb-error *ngIf="formHeader.get('fechaFin').hasError('required')">Ingrese fecha fin
                        </mdb-error>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="permiteUnidadNegocio">
                    <div class="col">
                      <div class="md-form">
                        <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                          placeholder="Unidad de negocio" [filterEnabled]="true"
                          formControlName="unidad_negocio_codigo">
                        </mdb-select>
                        <div *ngIf="
                        formHeader.get('unidad_negocio_codigo').invalid &&
                        (formHeader.get('unidad_negocio_codigo').dirty ||
                        formHeader.get('unidad_negocio_codigo').touched)
                      ">
                          <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                            de negocio
                          </mdb-error>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="formCondicion" (ngSubmit)="agregarItemCondicion()">
            <div class="row" style="border-bottom: 1px solid #dee2e6;">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Condiciones de Promoción
                </h5>
              </div>
            </div>

            <div class="row filtros-body">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="codigoCond" class="form-control" placeholder="" required #codigoCond
                    formControlName="codigo" />
                  <label for="codigoCond">Ingrese código</label>
                  <div *ngIf="
                    formCondicion.get('codigo').invalid &&
                    (formCondicion.get('codigo').dirty ||
                    formCondicion.get('codigo').touched)
                  ">
                    <mdb-error *ngIf="formCondicion.get('codigo').hasError('required')">Ingrese código de producto
                    </mdb-error>
                    <mdb-error *ngIf="formCondicion.get('codigo').hasError('min')">Código de producto debe ser
                      mayor a 0 </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex" style="display: flex; align-items: center;">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarProductoCondicion()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>

                <h6 class="text-info" *ngIf="productoSeleccionadoCondicion">
                  {{ productoSeleccionadoCondicion.descripcion}}
                </h6>
              </div>
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Formato" [options]="optionsFormatoCondicion" placeholder="Formato"
                    [filterEnabled]="true" formControlName="formato">
                  </mdb-select>
                  <div *ngIf="
                    formCondicion.get('formato').invalid &&
                    (formCondicion.get('formato').dirty ||
                    formCondicion.get('formato').touched)
                  ">
                    <mdb-error *ngIf="formCondicion.get('formato').hasError('required')">Ingrese formato
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="cantCond" class="form-control" required formControlName="cantidad"
                    #cantCond monto />
                  <label for="cantCond">Cantidad</label>
                  <div *ngIf="
                    formCondicion.get('cantidad').invalid &&
                    (formCondicion.get('cantidad').dirty ||
                    formCondicion.get('cantidad').touched)
                  ">
                    <mdb-error *ngIf="formCondicion.get('cantidad').hasError('required')">Ingrese cantidad
                    </mdb-error>
                    <mdb-error *ngIf="formCondicion.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row card-footer text-muted filtros-footer" style="
              border-top: 1px solid #dee2e6;
              border-bottom: 1px solid #dee2e6;
            ">
              <div></div>
              <button mdbBtn type="submit" color="indigo" mdbWavesEffect>
                Agregar
              </button>
            </div>
          </form>
        </div>

        <div class="table-responsive" style="margin-top: 20px;">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Formato</th>
                <th scope="col">Cantidad</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let promo of listaPromocionesCondicion; trackBy: trackByPromoCodigo">
                <td>{{ promo.sku }}</td>
                <td>{{ promo.descripcion }}</td>
                <td>{{ promo.formatoGlosa }}</td>
                <td>{{ promo.cantidad | numerico }}</td>
                <td>
                  <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                    (click)="eliminarItemCondicion(promo.index)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <form [formGroup]='formPromocion' (ngSubmit)="agregarItemPromocion()">
          <div class="filtros">
            <div class="row" style="border-bottom: 1px solid #dee2e6;">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Productos promoción
                </h5>
              </div>
            </div>
            <div class="row filtros-body">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="codigoProducto" class="form-control" placeholder="" required
                    formControlName="codigo" #codigoProducto />
                  <label for="codigoProducto">Código de producto</label>
                  <div *ngIf="
                    formPromocion.get('codigo').invalid &&
                    (formPromocion.get('codigo').dirty ||
                    formPromocion.get('codigo').touched)
                  ">
                    <mdb-error *ngIf="formPromocion.get('codigo').hasError('required')">Ingrese código de producto
                    </mdb-error>
                    <mdb-error *ngIf="formPromocion.get('codigo').hasError('min')">Código de producto debe ser
                      mayor a 0 </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex" style="display: flex; align-items: center;">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarProductoPromocion()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>

                <h6 class="text-info" *ngIf="productoSeleccionadoPromocion">
                  {{ productoSeleccionadoPromocion.descripcion}}
                </h6>
              </div>

              <div class="col">
                <div class="md-form">
                  <mdb-select label="Formato" [options]="optionsFormatoPromocion" placeholder="Formato"
                    [filterEnabled]="true" formControlName="formato">
                  </mdb-select>
                  <div *ngIf="
                    formPromocion.get('formato').invalid &&
                    (formPromocion.get('formato').dirty ||
                    formPromocion.get('formato').touched)
                  ">
                    <mdb-error *ngIf="formPromocion.get('formato').hasError('required')">Ingrese formato
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="cantCond" class="form-control" required formControlName="cantidad"
                    #cantCond monto />
                  <label for="cantCond">Cantidad</label>
                  <div *ngIf="
                    formPromocion.get('cantidad').invalid &&
                    (formPromocion.get('cantidad').dirty ||
                    formPromocion.get('cantidad').touched)
                  ">
                    <mdb-error *ngIf="formPromocion.get('cantidad').hasError('required')">Ingrese cantidad
                    </mdb-error>
                    <mdb-error *ngIf="formPromocion.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="md-form">
                  <mdb-select label="Tipo de descuento" [options]="optionsTipoDescuento" placeholder="Tipo de descuento"
                    formControlName="tipoDescuento" [filterEnabled]="true"></mdb-select>
                  <div *ngIf="
                      formPromocion.get('tipoDescuento').invalid &&
                      (formPromocion.get('tipoDescuento').dirty ||
                      formPromocion.get('tipoDescuento').touched)
                    ">
                    <mdb-error *ngIf="formPromocion.get('tipoDescuento').hasError('required')">Ingrese tipo de descuento
                    </mdb-error>
                  </div>
                </div>
              </div>

              <!-- <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder="Valor ($ o %)"
                    formControlName="montoOrPorcentaje" required #montoPorcentaje monto />
                  <label for="montoPorcentaje">Monto o Porcentaje</label>
                </div>
              </div> -->
              <div class="col">
                <div class="md-form">

                  <div *ngIf="formPromocion.get('tipoDescuento').value === '1'" >
                    <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder="Valor ($)"
                    formControlName="montoOrPorcentaje" required #montoPorcentaje monto/>
                  </div>
                  <div *ngIf="formPromocion.get('tipoDescuento').value === '2'" >
                    <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder="Valor (%)"
                    formControlName="montoOrPorcentaje" required #montoPorcentaje/>
                  </div>

                  <label for="montoPorcentaje">
                    <span
                      *ngIf="formPromocion.get('tipoDescuento').value !== '1' && formPromocion.get('tipoDescuento').value !== '2'">Monto
                      o Porcentaje</span>
                    <span *ngIf="formPromocion.get('tipoDescuento').value === '1'">Monto</span>
                    <span *ngIf="formPromocion.get('tipoDescuento').value === '2'">Porcentaje</span>
                  </label>
                  <div *ngIf="
                    formPromocion.get('montoOrPorcentaje').invalid &&
                    (formPromocion.get('montoOrPorcentaje').dirty ||
                    formPromocion.get('montoOrPorcentaje').touched)
                  ">
                    <mdb-error *ngIf="formPromocion.get('montoOrPorcentaje').hasError('required')">Ingrese monto o
                      porcentaje
                    </mdb-error>
                    <mdb-error *ngIf="formPromocion.get('montoOrPorcentaje').hasError('min')">Monto o porcentaje debe
                      ser
                      mayor a 0 </mdb-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row card-footer text-muted filtros-footer" style="
              border-top: 1px solid #dee2e6;
              border-bottom: 1px solid #dee2e6;
            ">
              <div></div>
              <button mdbBtn type="submit" color="indigo" mdbWavesEffect>
                Agregar
              </button>
            </div>
          </div>
        </form>

        <div class="table-responsive" style="margin-top: 20px;">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Formato</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Valor</th>
                <th scope="col">Tipo de descuento</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let promo of listaPromocionesPromocion; trackBy: trackByPromoCodigo">
                <td>{{ promo.sku }}</td>
                <td>{{ promo.descripcion }}</td>
                <td>{{ promo.formatoGlosa }}</td>
                <td>{{ promo.cantidad | numerico }}</td>
                <!-- <td>{{ promo.valor | numerico }}%</td> -->
                <td *ngIf="promo.tipoDescuento === '1'">$ {{ promo.monto | numerico }}</td>
                <td *ngIf="promo.tipoDescuento === '2'">{{ promo.porcentaje}} %</td>
                <td>{{ promo.tipoDescuentoGlosa }}</td>
                <td>
                  <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                    (click)="eliminarItemPromocion(promo.index)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="guardar()"
          [disabled]="listaPromocionesCondicion.length === 0 || listaPromocionesPromocion.length === 0"
          *ngIf="mode === 'ADD' || mode === 'EDIT'">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT">
</app-modal-seleccionar-cliente>
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>


<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [origen]="MODAL_SEL_PROD_CONDICION" (onSelect)="onProductoSeleccionadoCondicion($event)"
  [showFiltroActivoInactivo]="false" (onNotFound)="onProductoNoEncontradoCondicion()"
  (onRemoteQuery)="getProductsByUnidadNegocio($event)">
</app-modal-seleccionar-producto>
<app-modal-seleccionar-producto [origen]="MODAL_SEL_PROD_PROMOCION" (onSelect)="onProductoSeleccionadoPromocion($event)"
  [showFiltroActivoInactivo]="false" (onNotFound)="onProductoNoEncontradoPromocion()"
  (onRemoteQuery)="getProductsByUnidadNegocio($event)">
</app-modal-seleccionar-producto>

<app-modal-show-clientes>
</app-modal-show-clientes>
